import { render, staticRenderFns } from "./MessageIcon2.vue?vue&type=template&id=251ad00a&"
import script from "./MessageIcon2.vue?vue&type=script&lang=js&"
export * from "./MessageIcon2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports